import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Identifiable, Project, ProjectPortfolio } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  assignProjectToPortfolio(
    request: Boundaries["assignProjectToPortfolio"]["request"],
  ): void;
}

function useAssignProjectToPortfolio(
  project: Identifiable<Project>,
  portfolio: Identifiable<ProjectPortfolio>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isAssignProjectToPortfolioRequestPending(project, portfolio),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isAssignProjectToPortfolioRequestSuccess(project, portfolio),
    ),
    isRequestFailure: useSelector(() =>
      selector.isAssignProjectToPortfolioRequestFailure(project, portfolio),
    ),
    assignProjectToPortfolio: core.assignProjectToPortfolio,
  };
}

export { useAssignProjectToPortfolio };
